"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = function getDisplayName(o) {
  return o.displayName || o.constructor.displayName || o.constructor.name;
};
exports.getDisplayName = getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/why-did-you-update/lib/getDisplayName.js
// module id = 684
// module chunks = 0